<template>
  <card class="card-stats" :show-footer-line="true">
    <div class="row">
      <div class="col">
        <slot>
          <h5 class="card-title font-14 font-weight-600 text-white mb-0" v-if="title">
            {{ title }}
          </h5>
          <span class="mb-0 text-white font-12 pt-2 d-block sub-title" style="line-height: normal;" v-if="subTitle">{{
            subTitle
          }}</span>
        </slot>
      </div>

      <div class="col-auto" v-if="$slots.icon || icon">
        <slot name="icon">
          <div
            class="icon icon-shape text-white rounded-circle shadow"
            :class="[`bg-${type}`, iconClasses]"
          >
            <i :class="icon"></i>
          </div>
        </slot>
      </div>
    </div>

    <p class="mt-2 mb-0 text-sm text-white">
      <slot name="footer">
        <a class="text-white" v-if="readMoreLinkEnable" :href="readMoreLink"> {{ readMore }} <img src="../assets/img/General/readmore.svg" alt="moreinfo"></a>
       </slot>
    </p>
  </card>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "stats-card",
  components: {
    Card,
  },
  props: {
    type: {
      type: String,
      default: "primary",
    },
    icon: String,
    title: String,
    subTitle: String,
    readMore : String,
    readMoreLink : String,
    iconClasses: [String, Array],
    readMoreLinkEnable:{
      type: Boolean,
      default:true,
    },
  },
};
</script>
<style></style>
